module.exports = __webpack_public_path__ + "static/media/mental-threats-large.cbea2d22.png";